import { Dispatch } from 'redux';
import { LocationDescriptorObject } from 'history';

import { setCookie, getCookie } from 'ha/modules/Cookies';

import newTracker from './tracker';

const legacyCookieNames = {
  google: 'gclid',
  facebook: 'fbclid',
};

const getCookieName = (providerName: string): string => {
  return legacyCookieNames[providerName] || providerName;
};

export default function newReduxTracker(dispatch: Dispatch) {
  // the key value store is implemented using the cookies module
  const keyValueStore = {
    get: (provider: string): string => {
      return (dispatch(
        getCookie(getCookieName(provider)),
      ) as unknown) as string;
    },
    set: (provider: string, value: string, expireInDays: number) => {
      return dispatch(
        setCookie(getCookieName(provider), value, { expires: expireInDays }),
      );
    },
  };

  const tracker = newTracker(keyValueStore);

  const getSource = () => tracker.getSource();
  const trackSource = (location: LocationDescriptorObject) =>
    tracker.trackSource(location);

  return {
    getSource,
    trackSource,
  };
}
